// extracted by mini-css-extract-plugin
export default {"itens":"Categoria_itens__Q--ie"};